/// <reference path="Constants.js"/>
/// <reference path="Helpers.js"/>
/// <reference path="GeneralSettings.js" />

(function (sb) {
	sb.DynamicFiltering = (sb.DynamicFiltering || {});

	var _previousSelectedSettings = "";
	var _previousResult;
	var _ajaxCallId = 0;
	var _btnUpdateChartsClickEvents = null;

	function standardOptionValueParser(value) { return parseInt(value); }

	function timePeriodProcessor(data, isInitDataLoad) {
		var $timePeriodSelectBox = $("#lbSetting_3");


		if(data.datesWithData)
			Storyboard.DynamicDates.setDatesWithData(data.datesWithData);
		else
			Storyboard.DynamicDates.resetDatesWithData();

		if ($timePeriodSelectBox.closest(".dynamicFiltering").hasClass('dynamicFilteringLastSelected'))
			return;

		var noDataTimePeriods = data.noDataSelections;

		var prepPeriodType = $timePeriodSelectBox.find(":selected").attr('data-prep-time-period-type');

		if (data.datesWithData && prepPeriodType) {
			var dateVarId = $('#lbSetting_3_DateVariable').val() || 1;
			var $prepPeriodItemSelectBox = $('#ddlPrepPeriodItem_3');
			if ($prepPeriodItemSelectBox.attr('data-loaded-date-var') == dateVarId) {

				// special method for time period items
				processPrepSelectBoxAndPrep($prepPeriodItemSelectBox, data.datesWithData, prepPeriodType);
			}
		}

		if(noDataTimePeriods) {
			processSelectBox($timePeriodSelectBox, noDataTimePeriods, standardOptionValueParser);			
			return;
		}
	}

	function filterProcessor(data, isInitDataLoad) {
		var noDataFilters = data.noDataSelections;

		function filterValueParser(optionValue) { return parseInt(optionValue.split('-')[1]); }

		for (var filterId in noDataFilters) {
			if (noDataFilters.hasOwnProperty(filterId)) {
				var answerIds = noDataFilters[filterId];
				var $filterSelectBox = $("#lbSetting_5_" + filterId);

				if ($filterSelectBox.closest(".dynamicFiltering").hasClass('dynamicFilteringLastSelected'))
					continue;

				processSelectBox($filterSelectBox, answerIds, filterValueParser);
			}
		}
	}

	function hFilterProcessor(data, isInitDataLoad) {
		if (!Storyboard.HFilterLayout.hasHFilterNodes() || !Storyboard.HFilterLayout.isDynamicFilteringEnabled() || ($("#hfilterTree").hasClass("dynamicFilteringLastSelected") && !isInitDataLoad))
			return;

		var noDataHfilters = data.noDataSelections;

		sb.HFilterLayout.setNoDataNodes(noDataHfilters);
		sb.HFilterLayout.performDynamicFiltering();

		var hFilterLayout = Storyboard.LayoutDesigner.getHFilterLayout();

		if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLIST || hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERTREE)
			reloadHFilter(hFilterLayout);

		var noDataNodes = Storyboard.HFilterLayout.getLoadedNoDataNodes();
		if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLISTPERLEVEL && noDataNodes.length) {
			$("#hfilterTree").find("select").each(function (idx, elem) {
				var $filterSelectBox = $(elem);
				processSelectBox($filterSelectBox, noDataNodes, standardOptionValueParser);
			});
		}
	}

	function reloadHFilter(hFilterLayout) {

		var hFilterSelectionMode = Storyboard.LayoutDesigner.getHFilterSelectionMode();
		var oldVarSubSelections = $('#lbSetting_1').val();
		$.when(GeneralSettings.reloadHFilter(hFilterLayout, hFilterSelectionMode)).then(function () {
			if (oldVarSubSelections) {
				$('#lbSetting_1').val(oldVarSubSelections);
				$('#lbSetting_1').multiselect("refresh");
			}
		});
	}

	function processSelectBoxWithStandardParser($selectBox, noDataValues) {
		processSelectBox($selectBox, noDataValues, standardOptionValueParser)
	}

	function processSelectBox($selectBox, noDataValues, valueParser) {
		var $options = $selectBox.find('option');
		var disableOptions
			= $selectBox.closest(".dynamicFiltering").data("dynamicFiltering") === sb.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData

		$options.each(function (idx, option) {
			var $option = $(option);
			var value = $option.val();

			if (noDataValues.includes(valueParser(value))) {
				$option.data("noData", true);
				if (disableOptions)
					$option.attr("disabled", "disabled");
				else
					$option.attr("hidden", "hidden");
			}
		});
	}

	function processPrepSelectBoxAndPrep($selectBox, _noDataValues, prepPeriodType) {
		var $options = $selectBox.find('option');
		var dateVariableId = $('#lbSetting_3_DateVariable').val() || 1;
		var disableOptions
			= $selectBox.closest(".dynamicFiltering").data("dynamicFiltering") === sb.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData;
		var year, quarter, month, week, day, momentDate;

		function hasData(value) {
			value = value.split('_').slice(1).join('_');

			switch (Number(prepPeriodType)) {
				case Storyboard.Constants.IntervalTypes.DAY:
					momentDate = moment(value, 'YYYY_MM_DD');
					year = momentDate.year();
					month = momentDate.month() + 1;
					day = momentDate.date();
					return Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year, month, day });

				case Storyboard.Constants.IntervalTypes.WEEK:
					momentDate = moment(value, 'YYYY_WW');
					year = momentDate.year();
					week = momentDate.week();
					return Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year, week });

				case Storyboard.Constants.IntervalTypes.MONTH:
					momentDate = moment(value, 'YYYY_MM');
					year = momentDate.year();
					month = momentDate.month() + 1;
					return Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year, month });

				case Storyboard.Constants.IntervalTypes.QUARTER:
					momentDate = moment(value, 'YYYY_Q');
					year = momentDate.year();
					quarter = momentDate.quarter();
					return Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year, quarter });

				case Storyboard.Constants.IntervalTypes.YEAR:
					momentDate = moment(value, 'YYYY');
					year = momentDate.year();
					return Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year });
				
				default:
					return true;
			}
		}

		$options.each(function (idx, option) {
			var $option = $(option);
			var value = $option.val();

			if (!hasData(value)) {
				$option.data("noData", true);
				if (disableOptions)
					$option.attr("disabled", "disabled");
				else
					$option.attr("hidden", "hidden");
			}
		});
	}

	function isEnabled() {
		return $('.dynamicFiltering').length > 0 || Storyboard.HFilterLayout.isDynamicFilteringEnabled();
	}

	function selectionsChanged(request) {
		var currentSelections = JSON.stringify(request.filters) + "_" + JSON.stringify(request.hfilters) + "_" + JSON.stringify(request.timePeriod);
		if (currentSelections === _previousSelectedSettings)
			return false;

		_previousSelectedSettings = currentSelections;
		return true;
	}

	function processNoDataSelections(data, isInitDataLoad) {
		data.forEach(function (noDataSelections) {
			processors[noDataSelections.settingType](noDataSelections, isInitDataLoad);
		});
	}

	function fixDefaultSelectionVsNoDataFilterConflict(selectedFilters, noDataSelectionsArray) {
		if (!selectedFilters || !noDataSelectionsArray)
			return;

		var filterNoData = (_.findWhere(noDataSelectionsArray, { settingType: 5 }));
		if (!filterNoData || !filterNoData.noDataSelections)
			return;

		var filterNoDataSelections = filterNoData.noDataSelections;
		if (!filterNoDataSelections)
			return;

		var resetToNoSelection = [];

		for (var filterId in filterNoDataSelections) {
			if (filterNoDataSelections.hasOwnProperty(filterId)) {
				filterNoDataSelections[filterId].forEach(function (answerId) {
					if (~selectedFilters[filterId].indexOf(String(answerId))) {
						resetToNoSelection.push(filterId);
					}
				});
			}
		}

		resetToNoSelection.forEach(function (filterId) {
			var $ul = null;
			var $elemSel = $("#lbSetting_5_" + filterId).val("0-0");
			$elemSel.find('option').each(function (idxOpt, elemOpt) {
				var optionValue = $(elemOpt).val();
				var $li = $('#li_' + $elemSel.attr('id') + '-' + optionValue);
				$ul = $ul || $li.closest('ul');
				var inputField = $li.find('input').first();
				if (optionValue == "0-0") {
					inputField.attr('checked', 'checked');
				}
				else {
					inputField.removeAttr('checked');
				}
			});
			$elemSel.val("0-0").multiselect("update");
		});
	}

	function applyPreviousNoDataSelections(currentSelectBox) {
		if (!sb.DynamicFiltering.isEnabled())
			return;

		if (_previousResult) {
			removeNoDataMarkers();
			processNoDataSelections(_previousResult, false);

			refreshSelectBoxes(null, currentSelectBox);
			$(document).trigger('DAPI.dynamicFilteringLoaded');
		}
	}

	function getNoDataSelections(reportLoad) {
		_ajaxCallId++;
		var currentAjaxCallId = _ajaxCallId; 

		var request = getUserSelectedSettings();
		if (!selectionsChanged(request)) {
			restoreClickEventsFromBtnUpdateCharts();
			return;
		}

		addLoadingAttributes();

		var promise = Helpers.perfJSonCall({
			method: "GetDynamicFilteringNoDataSelections",
			message: locale.get("Loading Filters"),
			data: { request: request },
			fixCasing: true
		});

		promise.done(function (response) {
			if(currentAjaxCallId !== _ajaxCallId)
				return;
			restoreClickEventsFromBtnUpdateCharts();
			removeLoadingAttributes();
			removeNoDataMarkers();
			processNoDataSelections(response.d, false);

			if(reportLoad && Storyboard.GeneralSettings.hasHFilter())
				fixDefaultSelectionVsNoDataFilterConflict(request.filters, response.d);

			refreshSelectBoxes();

				_previousResult = response.d;
				$(document).trigger('DAPI.dynamicFilteringLoaded');
		});

		promise.fail(function () {
			restoreClickEventsFromBtnUpdateCharts();
			removeLoadingAttributes();
		});

		return promise;
	}

	function getUserSelectedSettings() {
		return populateLastSelectedSetting(getSelectedSettings(true));
	}

	function getSelectedSettings(includeOnlyDynamic) {
		var settings = {};

		// Filters and Time periods
		var filterAndTimePeriodSelector = includeOnlyDynamic ? "#pnlSettingsPanel .SettingsControl.dynamicFiltering" : "#pnlSettingsPanel .SettingsControl";
		$(filterAndTimePeriodSelector).not('.HideFilter, .myStorySettingsControl').each(function () {
			var settingType = parseInt($(this).find(".hidSettingType").val(), 10);
			if (!settingType) return;

			var $select = $(this).find('select');

			var selections = [];

			$select.multiselect('getChecked').each(function(idx,elem){
				selections.push($(elem).val());
			});

			if (settingType == 5) {
				var filterId = $select.attr("id").split("_")[2];
				settings.filters = settings.filters || {};
				settings.filters[filterId] = selections.map(function (val) { return val.split("-")[1] });
			}

			if (settingType == 3) {

				var dateVariable = $('#lbSetting_3_DateVariable').val();
				var tp = settings.timePeriod = settings.timePeriod || {};
				tp.TimePeriodId = selections[0];
				var prepPeriodType = $select.find('option[value="' + tp.TimePeriodId + '"]').attr('data-prep-time-period-type');

				if (dateVariable) {
					tp.DateVariableId = dateVariable;
				}

				if (tp.TimePeriodId == "-2") { // custom period
					tp.StartDate = $(this).find(".optCustomPeriodStart").datepicker('getDate').format('yyyy/MM/dd');
					tp.EndDate = $(this).find(".optCustomPeriodEnd").datepicker('getDate').format('yyyy/MM/dd');
				} else if (prepPeriodType > 0) {
					tp.StartDate = $(this).find('#ddlPrepPeriodItem_3 option:selected').attr('strStartDate');
					tp.EndDate = $(this).find('#ddlPrepPeriodItem_3 option:selected').attr('strStopDate');
				}
			}
		});

		// HFilters
		var selectedHFilters = Storyboard.GeneralSettings.hasHFilter()
			&& (includeOnlyDynamic && Storyboard.HFilterLayout.isDynamicFilteringEnabled()) ? Storyboard.HFilterLayout.getSelectedIds("#hfilterTree") : false;

		if (selectedHFilters && selectedHFilters.length > 0) {
			settings.hfilters = selectedHFilters;
		}

		return settings;
	}

	function addLoadingAttributes() {
		var dynamicFilteringElements = $('.dynamicFiltering').not('.dynamicFilteringLastSelected').addClass('dynamicFilteringInProgress');
		dynamicFilteringElements.find('button.ui-multiselect').prev('select').multiselect('disable');
		dynamicFilteringElements.find('button.DUITreeCompactButton').attr('disabled', true);
	}

	function removeLoadingAttributes() {
		var dynamicFilteringElements = $('.dynamicFiltering').removeClass('dynamicFilteringInProgress');

		dynamicFilteringElements.each(function() {
			if (!$(this).hasClass('NoOptionsFilter')) {
				$(this).find('button.ui-multiselect').prev('select').multiselect('enable');
			}
		});

		dynamicFilteringElements.find('button.DUITreeCompactButton').removeAttr('disabled');
	}

	function markLastSelectedSetting($element) {
		$('.dynamicFilteringLastSelected').removeClass('dynamicFilteringLastSelected');
		$element.addClass('dynamicFilteringLastSelected');
	}

	function populateLastSelectedSetting(settings) {
		var $lastSelected = $('.dynamicFilteringLastSelected');
		if (!$lastSelected.length)
			return settings;

		if ($lastSelected.attr('id') === "hfilterTree") {
			settings.isHFiltersLastSelected = true;
			return settings;
		}

		var settingIds = $lastSelected.find("select[id^='lbSetting_']").attr('id').split("_");
		if (settingIds.length > 1 && Number(settingIds[1]) === Storyboard.Constants.SettingTypes.Filter) {
			settings.lastSelectedFilterId = settingIds[2];
			return settings;
		}

		if (settingIds.length > 1 && Number(settingIds[1]) === Storyboard.Constants.SettingTypes.TimePeriod) {
			settings.isTimePeriodLastSelected = true;
			return settings;
		}

		return settings;
	}

	function removeNoDataMarkers() {
		$('.dynamicFiltering').not('.dynamicFilteringLastSelected').find('option').each(function (idx, option) {
			var $option = $(option);
			if ($option.data("noData")) {
				$option.data("noData", false).removeAttr('disabled').removeAttr("hidden");
			}
		});
	}

	function removeClickEventsFromBtnUpdateCharts() {
		_btnUpdateChartsClickEvents = _btnUpdateChartsClickEvents || $('#btnUpdateCharts').data('events').click;
		$('#btnUpdateCharts').data('events').click = [];
		$('#btnUpdateCharts').css({ 'opacity' : '0.5'});
	}

	function restoreClickEventsFromBtnUpdateCharts() {
		if(_btnUpdateChartsClickEvents && _btnUpdateChartsClickEvents.length)
			$('#btnUpdateCharts').data('events').click = _btnUpdateChartsClickEvents;
		
		$('#btnUpdateCharts').css('opacity', '1');
	}

	function restoreEnabledOptionsSortOrder($enabledOptions) {
		$enabledOptions.forEach(function ($li, idx) {
			var $lastEnabledOption = $enabledOptions[idx - 1];
			if ($li.data('re-enable'))
				$li.insertAfter($lastEnabledOption);
		});
	}

	function refreshSelectBox(ind, selEl) {
		var $selEl = $(selEl);

		var moveDisabledToBottom = $selEl.closest(".dynamicFiltering").data("dynamicFilteringMoveDisabledToBottom");
		var $ul = null;

		var $enabledOptions = [];

		$selEl.find('option').each(function (indOpt, optEl) {
			var $optEl = $(optEl);
			var $li = $('#li_' + selEl.id + '-' + $optEl.val());
			$ul = $ul || $li.closest('ul');

			var inputField = $li.find('input').first();

			if ($optEl.attr('disabled')) {
				$li.addClass('ui-multiselect-disabled');
				inputField.parents('label').first().addClass('ui-state-disabled');
				inputField.attr('disabled', 'disabled');

				if (moveDisabledToBottom) {
					$li.appendTo($ul);
				}
			}
			else {
				if (moveDisabledToBottom) {
					$enabledOptions.push($li.data('re-enable', $li.hasClass('ui-multiselect-disabled')));
				}

				$li.removeClass('ui-multiselect-disabled');
				inputField.parents('label').first().removeClass('ui-state-disabled');
				inputField.attr('disabled', '');
			}

			if ($optEl.attr('hidden')) {
				$li.addClass('ui-multiselect-hidden');
				inputField.attr('hidden', 'hidden');
			}
			else {
				$li.first().removeClass('ui-multiselect-hidden');
				inputField.attr('hidden', '');
			}
		});

		if (moveDisabledToBottom && $enabledOptions && $enabledOptions.length > 1) {
			restoreEnabledOptionsSortOrder($enabledOptions);
		}

		// Lazy render is used, try to render more options if not enough are shown
		if (Storyboard.GeneralSettings.filterLazyRenderCount > 0 &&
			$selEl.multiselect('widget').find('.ui-multiselect-checkboxes li:not(.ui-multiselect-hidden)').length < Storyboard.GeneralSettings.filterLazyRenderCount)
			$selEl.multiselect('renderMore');
	}

	function refreshOpenedSelectBox(ind, selEl) {
		var $selEl = $(selEl);

		var moveDisabledToBottom = $selEl.closest(".dynamicFiltering").data("dynamicFilteringMoveDisabledToBottom");
		var $ul = null;

		var $enabledOptions = [];

		$selEl.multiselect('refresh');

		$selEl.find('option').each(function (indOpt, optEl) {
			var $optEl = $(optEl);
			var $li = $('#li_' + selEl.id + '-' + $optEl.val());
			$ul = $ul || $li.closest('ul');

			if ($optEl.attr('disabled')) {
				if (moveDisabledToBottom) {
					$li.appendTo($ul);
				}
			}
			else {
				if (moveDisabledToBottom) {
					$enabledOptions.push($li.data('re-enable', $li.hasClass('ui-multiselect-disabled')));
				}
			}
		});

		if (moveDisabledToBottom && $enabledOptions && $enabledOptions.length > 1) {
			restoreEnabledOptionsSortOrder($enabledOptions);
		}

		// Lazy render is used, try to render more options if not enough are shown
		if (Storyboard.GeneralSettings.filterLazyRenderCount > 0 &&
			$selEl.multiselect('widget').find('.ui-multiselect-checkboxes li:not(.ui-multiselect-hidden)').length < Storyboard.GeneralSettings.filterLazyRenderCount)
			$selEl.multiselect('renderMore');
	}

	function refreshSelectBoxes(currentSelectBox, boxToRefresh) {
		if (currentSelectBox) {
			$('.dynamicFiltering select').not(currentSelectBox).each(refreshSelectBox);
			refreshOpenedSelectBox(currentSelectBox);
		} else if (boxToRefresh) {
			$('.dynamicFiltering select#' + boxToRefresh.attr('id')).each(refreshSelectBox);
		} else {
			$('.dynamicFiltering select').each(refreshSelectBox);
		}
	}

	function reportLoadDynamicFiltering(ignoreLastSelectedFilterId){
		var request = getSelectedSettings(true);
		var lastSelectedFilterId = getLastSelectedFilterId(request.filters);

		var result = null;

		if (Storyboard.GeneralSettings.hasHFilter() && $("#hfilterTree").hasClass('dynamicFiltering')) {
			result = (lastSelectedFilterId != "0") 
				? filterByHFilterThenOptionalFilter(request, lastSelectedFilterId)
				: filterByHFilter(request);
		} else if ($('#lbSetting_3').length > 0 && $("#lbSetting_3").closest('.SettingsControl').hasClass('dynamicFiltering')) {
			result = (lastSelectedFilterId != "0") 
				? filterByTimePeriodThenOptionalFilter(request, lastSelectedFilterId)
				: filterByTimePeriod(request);
		} else {
			result = (!ignoreLastSelectedFilterId && lastSelectedFilterId != "0")
				? filterByOptionalFilter(request, lastSelectedFilterId)
				: filterByOptionalFilter(request);
		}

		return result.done(finalizeDyamicFiltering).fail(filteringFailed);
	}

	function filterByHFilterThenOptionalFilter(request, lastSelectedFilterId) {
		return filterByHFilter(request).done(function(){return filterByOptionalFilter(request, lastSelectedFilterId)})
	}

	function filterByHFilter(request){
		markLastSelectedSetting($("#hfilterTree"));
		addLoadingAttributes();

		delete request.lastSelectedFilterId;
		request.isHFiltersLastSelected = true;
		request.isInitDataLoad = true;
		return getDynamicFilteringResult(request).done(function (response) { applyResults(response.d, request.isInitDataLoad)});
	}

	function filterByTimePeriodThenOptionalFilter(request, lastSelectedFilterId) {
		return filterByTimePeriod(request).done(function(){return filterByOptionalFilter(request, lastSelectedFilterId)})
	}

	function filterByTimePeriod(request){
		markLastSelectedSetting($("#lbSetting_3"));
		addLoadingAttributes();

		delete request.lastSelectedFilterId;
		request.isTimePeriodLastSelected = true;
		request.isInitDataLoad = true;
		return getDynamicFilteringResult(request).done(function (response) { applyResults(response.d, request.isInitDataLoad)});
	}

	function filterByOptionalFilter(request, lastSelectedFilterId){
		if(lastSelectedFilterId && lastSelectedFilterId != "0")
		{
			if (request.isInitDataLoad) {
				delete request.isInitDataLoad;
			}

			markLastSelectedSetting($("#lbSetting_5_" + lastSelectedFilterId).closest('.dynamicFiltering'));
			request.lastSelectedFilterId = lastSelectedFilterId;
		}

		addLoadingAttributes();

		delete request.isHFiltersLastSelected;
		delete request.isTimePeriodLastSelected;
		return getDynamicFilteringResult(request).done(function (response) { applyResults(response.d, request.isInitDataLoad)});
	}

	function applyResults(result, isInitDataLoad) {
		removeLoadingAttributes();
		removeNoDataMarkers();
		processNoDataSelections(result, isInitDataLoad);
		refreshSelectBoxes();
	}

	function filteringFailed(){
		restoreClickEventsFromBtnUpdateCharts();
		removeLoadingAttributes();
	}

	function getLastSelectedFilterId(filters){
		var lastSelectedFilterId = 0;
		if (filters) {
			for (var filterId in filters) {
				if (filters.hasOwnProperty(filterId) && (filters[filterId].length > 0) && ((filters[filterId])[0] != 0)) {
					lastSelectedFilterId = filterId;
					break;
				}
			}
		}
		
		return lastSelectedFilterId;
	}

	function getDynamicFilteringResult(request) {
		return Helpers.perfJSonCall({
			method: "GetDynamicFilteringNoDataSelections",
			message: locale.get("Loading Filters"),
			data: { request: request },
			fixCasing: true
		});
	}

	function finalizeDyamicFiltering(result) {
		restoreClickEventsFromBtnUpdateCharts();
		_previousResult = result.d;
		$(document).trigger('DAPI.dynamicFilteringLoaded');
	}

	// Export stuff to the world
	var processors = {
		"3": timePeriodProcessor,
		"5": filterProcessor,
		"6": hFilterProcessor
	};

	sb.DynamicFiltering.processors = processors;

	sb.DynamicFiltering.isEnabled = isEnabled;
	sb.DynamicFiltering.addLoadingAttributes = addLoadingAttributes;
	sb.DynamicFiltering.removeLoadingAttributes = removeLoadingAttributes;
	sb.DynamicFiltering.getNoDataSelections = getNoDataSelections;
	sb.DynamicFiltering.removeNoDataMarkers = removeNoDataMarkers;
	sb.DynamicFiltering.refreshSelectBoxes = refreshSelectBoxes;
	sb.DynamicFiltering.getUserSelectedSettings = getUserSelectedSettings;
	sb.DynamicFiltering.markLastSelectedSetting = markLastSelectedSetting;
	sb.DynamicFiltering.processSelectBoxWithStandardParser = processSelectBoxWithStandardParser;
	sb.DynamicFiltering.applyPreviousNoDataSelections = applyPreviousNoDataSelections;
	sb.DynamicFiltering.removeClickEventsFromBtnUpdateCharts = removeClickEventsFromBtnUpdateCharts;
	sb.DynamicFiltering.restoreClickEventsFromBtnUpdateCharts = restoreClickEventsFromBtnUpdateCharts;
	sb.DynamicFiltering.reportLoadDynamicFiltering = reportLoadDynamicFiltering;

}(window.Storyboard = (window.Storyboard || {})));
